import { Row, Col, Card, CardBody, CardTitle, CardHeader } from 'reactstrap';
import CustomSelect from '@myComponents/CustomSelect';
import CustomDatePickerRange from '@myComponents/CustomDatePickerRange';
import { useFilterOptions } from '../../../hooks';

export const CustomFilters = ({ errors, control, filterOptions }) => {
  const { options, loading } = useFilterOptions();

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h4">Filtros</CardTitle>
      </CardHeader>
      <CardBody>
        <Row>
          {filterOptions &&
            filterOptions.types.map((item) => {
              switch (item.type) {
                case 'select':
                  return (
                    <Col md="3" key={item.id}>
                      <CustomSelect
                        id={item.id}
                        name={item.name}
                        label={item.label}
                        control={control}
                        options={options[item.options]}
                        error={errors?.[item.name]}
                        loading={loading}
                        bottom
                      />
                    </Col>
                  );
                case 'selectOptions':
                  return (
                    <Col md="3" key={item.id}>
                      <CustomSelect
                        id={item.id}
                        name={item.name}
                        label={item.label}
                        control={control}
                        options={item.options}
                        error={errors?.[item.name]}
                        loading={loading}
                        bottom
                      />
                    </Col>
                  );
                case 'rangepicker':
                  return (
                    <Col md="3" key={item.id}>
                      <CustomDatePickerRange
                        id={item.id}
                        name={item.name}
                        label={item.label}
                        placeholder={item.placeholder}
                        control={control}
                        error={errors?.[item.name]}
                        bottom
                      />
                    </Col>
                  );
                default:
                  return null;
              }
            })}
        </Row>
      </CardBody>
    </Card>
  );
};
